<script>
	import { createEventDispatcher } from "svelte";
	const dispatch = createEventDispatcher();

	export let rating = 0;
	let act = 0;
</script>

<style>
	.star {
		font-size: 2.5em;
	}

	.grey {
		color: lightgrey;
	}
	.yellow {
		color: gold;
	}
</style>

{#each [1, 2, 3, 4, 5] as i}
	<span
		class="star clickable {((act ? act : rating) >= i)?'yellow':'grey'}"
		on:mouseenter={() => act = i}
		on:mouseleave={() => act = 0}
		on:click={() => dispatch('rate', i)}>
		&#x2605;
	</span>
{/each}
